import React, { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { Link } from '@utils/cook/types'
import Blink from '@components/Blink'
import TeamLogo from '@components/LayoutTabs/SubsectionReusableComponents/TeamLogo'

type SportEntityProps = {
  name: string
  image: {
    src: string
    alt: string
  }
  link?: Link
  children?: React.ReactNode
}

const StyledListSportEntity = styled.li`
  ${({
    theme: {
      spacing: { spacing8 },
      colors: { strokeWeak },
    },
  }) => css`
    padding: ${spacing8} 0;
    border-bottom: 1px solid ${strokeWeak};
    display: flex;
    gap: ${spacing8};
    align-items: center;
    min-height: 48px;
  `}
`

const StyledSportEntityText = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadCSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${small1SubheadCSS};
  `}
`

const StyledClickableTeamWrapper = styled(Blink)`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    appearance: none;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: ${spacing8};
  `}
`

const SportEntity: FunctionComponent<SportEntityProps> = ({
  image,
  name,
  link,
  children,
}) => (
  <StyledListSportEntity>
    {link ? (
      <StyledClickableTeamWrapper {...link}>
        <TeamLogo name={image?.alt} url={image?.src} size={40} />
        <StyledSportEntityText>{name}</StyledSportEntityText>
      </StyledClickableTeamWrapper>
    ) : (
      <>
        <TeamLogo name={image?.alt} url={image?.src} size={40} />
        <StyledSportEntityText>{name}</StyledSportEntityText>
      </>
    )}
    {children}
  </StyledListSportEntity>
)

export default SportEntity
